
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { KeyRound } from "lucide-react";

export const PasswordResetNotification = () => {
  return (
    <Alert className="mb-6 bg-blue-900/20 border-blue-700 dark:bg-blue-900/20 dark:border-blue-700">
      <KeyRound className="h-4 w-4 text-blue-400 dark:text-blue-400" />
      <AlertTitle className="text-blue-300 dark:text-blue-300">Password Reset Required</AlertTitle>
      <AlertDescription className="text-blue-400 dark:text-blue-400">
        Please set a new password to secure your account.
      </AlertDescription>
    </Alert>
  );
};
